import axios, { AxiosError } from 'axios';
import { Api } from '../../axiosApi';

interface ItemVenda {
  qtds: number;
  idmov: string;
  descricao: string;
  referencia: string;
  un: string;
  preco: number;
  total: number;
}
interface RomaneioVenda {
  idmov: string;
  emissao: string;
  numero: string | null;
  idparceiro: string;
  idoperacao: string;
  nome: string;
  cpf: string;
  descricao: string;
  tpag: string;
  vprod: number;
  desconto: number;
  acrescimo: number;
  total: number;
}
export interface Rreceber {
  romaneios: RomaneioVenda;
  itens: ItemVenda[];
}

interface ErrorResponse {
  errors: {
    default: string;
  };
}
// situacao: 'todas' (vencidas + a vencer) | 'vencidas' (só vencimento < hoje)
// | 'avencer' (só vencimento >= hoje) — filtro aplicado no backend.
// semperiodo: 'sim' ignora datainicial/datafinal e traz todos os lançamentos
// em aberto do parceiro (ex.: "total a receber daquele parceiro"); 'nao'
// aplica o período normalmente.
const Rreceber = async (
  parceiro: string,
  datainicial: string,
  datafinal: string,
  situacao: 'todas' | 'vencidas' | 'avencer' = 'todas',
  semperiodo: 'sim' | 'nao' = 'nao'
): Promise<Rreceber[] | Error> => {

  try {

    const urlRelativa =
      `/relatoriocontasreceber?parceiro=${parceiro}&situacao=${situacao}&semperiodo=${semperiodo}` +
      (semperiodo === 'sim' ? '' : `&datainicial=${datainicial}&datafinal=${datafinal}`);

    const { data } = await Api.get<Rreceber[]>(urlRelativa);

    if (data) {
      return data;
    }

    return new Error('Erro ao consultar o relatório de vendas.');

  } catch (error) {

    if (axios.isAxiosError(error)) {

      const axiosError = error as AxiosError<ErrorResponse>;

      if (axiosError.response) {

        const errorMessage =
          axiosError.response.data.errors?.default || 'Erro desconhecido';

        return new Error(errorMessage);

      } else if (axiosError.request) {

        return new Error('Nenhuma resposta do servidor');

      } else {

        return new Error(axiosError.message);

      }

    }

    return new Error('Erro inesperado');
  }
};

const Rrecebidas = async (
  parceiro: string,
  conta: string,
  datainicial: string,
  datafinal: string
): Promise<Rreceber[] | Error> => {

  try {

    const urlRelativa =
      `/relatoriocontasrecebidas?parceiro=${parceiro}&conta=${conta}&datainicial=${datainicial}&datafinal=${datafinal}`;
    const { data } = await Api.get<Rreceber[]>(urlRelativa);
    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o relatório de vendas.');

  } catch (error) {

    if (axios.isAxiosError(error)) {

      const axiosError = error as AxiosError<ErrorResponse>;

      if (axiosError.response) {

        const errorMessage =
          axiosError.response.data.errors?.default || 'Erro desconhecido';

        return new Error(errorMessage);

      } else if (axiosError.request) {

        return new Error('Nenhuma resposta do servidor');

      } else {

        return new Error(axiosError.message);

      }

    }

    return new Error('Erro inesperado');
  }
};



const Rpagar = async (
  parceiro: string,
  planoconta: string,
  agrupar: string,
  datainicial: string,
  datafinal: string
): Promise<Rreceber[] | Error> => {

  try {

    const urlRelativa =
      `/relatoriocontaspagar?parceiro=${parceiro}&planoconta=${planoconta}&agrupar=${agrupar}&datainicial=${datainicial}&datafinal=${datafinal}`;
    const { data } = await Api.get<Rreceber[]>(urlRelativa);
    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o relatório de vendas.');

  } catch (error) {

    if (axios.isAxiosError(error)) {

      const axiosError = error as AxiosError<ErrorResponse>;

      if (axiosError.response) {

        const errorMessage =
          axiosError.response.data.errors?.default || 'Erro desconhecido';

        return new Error(errorMessage);

      } else if (axiosError.request) {

        return new Error('Nenhuma resposta do servidor');

      } else {

        return new Error(axiosError.message);

      }

    }

    return new Error('Erro inesperado');
  }
};


const Rpagas = async (
  parceiro: string,
  planoconta: string,
  datainicial: string,
  datafinal: string
): Promise<Rreceber[] | Error> => {

  try {

    const urlRelativa =
      `/relatoriocontaspagas?parceiro=${parceiro}&planoconta=${planoconta}&datainicial=${datainicial}&datafinal=${datafinal}`;
    const { data } = await Api.get<Rreceber[]>(urlRelativa);
    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o relatório de vendas.');

  } catch (error) {

    if (axios.isAxiosError(error)) {

      const axiosError = error as AxiosError<ErrorResponse>;

      if (axiosError.response) {

        const errorMessage =
          axiosError.response.data.errors?.default || 'Erro desconhecido';

        return new Error(errorMessage);

      } else if (axiosError.request) {

        return new Error('Nenhuma resposta do servidor');

      } else {

        return new Error(axiosError.message);

      }

    }

    return new Error('Erro inesperado');
  }
};


export const RelatorioFinanceiroService = {
  Rreceber,
  Rrecebidas,
  Rpagar,
  Rpagas
};